const ALWAYS_SHOW = ['[AuthStore]', '[ServiceWorker]']

const ROUTE_MODULE_MAP = {
  Profile:               ['[profileStore]', '[useApi]'],
  ManageStudents:        ['[studentStore]', '[studentService', '[useStudentCRUD]', '[useGradeLogic]', '[useApi]'],
  TeacherDashboard:      ['[jobStore]', '[FeatureStore]', '[useApi]'],
  AILessonPlanGenerator: ['[useApi]', '[jobStore]'],
  AITestGenerator:       ['[useApi]'],
  AIExerciseGenerator:   ['[useApi]'],
  AIContentHistory:      ['[useApi]'],
  ExtractGrades:         ['[useApi]', '[jobStore]'],
  GradeExtractionHistory:['[useApi]'],
  Login:                 ['[useApi]'],
  Register:              ['[useApi]'],
  MyNotebooks:           ['[jobStore]', '[useApi]'],
  CreateNotebook:        ['[jobStore]', '[useApi]'],
  GamesLobby:            ['[useApi]'],
  GameViewer:            ['[useApi]'],
}

let activeModules = [...ALWAYS_SHOW]

export function setActiveRoute(routeName) {
  activeModules = [...ALWAYS_SHOW, ...(ROUTE_MODULE_MAP[routeName] || [])]
}

export function initConsoleFilter() {
  if (!import.meta.env.DEV) return

  const methods = ['log', 'warn', 'error', 'debug', 'info']
  const originals = {}

  methods.forEach(method => {
    originals[method] = console[method].bind(console)
    console[method] = (...args) => {
      const msg = String(args[0] ?? '')
      if (!msg.startsWith('[') || activeModules.some(m => msg.startsWith(m))) {
        originals[method](...args)
      }
    }
  })

  // منفذ طوارئ: console.__raw.log(...) يتجاوز الفلتر دائمًا
  console.__raw = originals
}
